function c(r) {
  return r.type === "group";
}
function a(r) {
  return r.type === "ignored";
}
function g(r, t) {
  try {
    return !!(1 + t.toString().toLowerCase().indexOf(r.trim().toLowerCase()));
  } catch {
    return !1;
  }
}
function p(r, t) {
  return {
    getIsGroup: c,
    getIgnored: a,
    getKey(e) {
      return c(e) ? e.name || e.key || "key-required" : e[r];
    },
    getChildren(e) {
      return e[t];
    }
  };
}
function h(r, t, f, e) {
  if (!t)
    return r;
  function n(s) {
    if (!Array.isArray(s))
      return [];
    const i = [];
    for (const u of s)
      if (c(u)) {
        const o = n(u[e]);
        o.length && i.push(Object.assign({}, u, {
          [e]: o
        }));
      } else {
        if (a(u))
          continue;
        t(f, u) && i.push(u);
      }
    return i;
  }
  return n(r);
}
function y(r, t, f) {
  const e = /* @__PURE__ */ new Map();
  return r.forEach((n) => {
    c(n) ? n[f].forEach((s) => {
      e.set(s[t], s);
    }) : e.set(n[t], n);
  }), e;
}
export {
  p as createTmOptions,
  y as createValOptMap,
  h as filterOptions,
  a as getIgnored,
  c as getIsGroup,
  g as patternMatched
};
